import { useSyncExternalStore } from "react";

export const TOKENS = {
  bg: "#ffffff",
  heading: "#861b68",
  body: "#000000",
  border: "#eeeeee",
  inputBorder: "#d9d9d9",
  muted: "#6b6b6b",
  gradient: "linear-gradient(135deg, #861b68, #a32480)",
  gradientShadow: "0 12px 30px #861b684d",
  radiusBtn: "28px",
  radiusCard: "20px",
  radiusInput: "14px",
  radiusOverlay: "24px",
  fontPrimary: "'Google Sans', sans-serif",
  fontSerif: "'PT Serif', serif",
  fontDisplay: "'Playfair Display', serif",
  maxWidth: "1400px",
};

export const VISIBILITY = { ALL: "all", SELECTED: "selected" };

export const VISIBILITY_OPTIONS = [
  {
    value: VISIBILITY.ALL,
    label: "View All",
    description: "Everyone in the Advertisment can view this advertisement.",
  },
  {
    value: VISIBILITY.SELECTED,
    label: "View Selected People",
    description: "Choose specific people who can view this advertisement.",
  },
];

export const EDIT_WINDOW_MS = 8 * 60 * 60 * 1000;
export const UNLOCK_PRICE_INR = 500;
export const FREE_VIEWER_COUNT = 4;
export const ADS_PER_PAGE = 4;

export const CURRENT_USER_ID = 1;

export const FALLBACK_AD_IMAGE =
  "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80";

export const MOCK_MEMBERS = [
  { id: 1, name: "Rahul Mehta", designation: "Managing Director", company: "ABC Hospitality", location: "Delhi", avatar: "RM", email: "rahul.mehta@example.com" },
  { id: 2, name: "Priya Sharma", designation: "Hotel Manager", company: "The Grand Palace", location: "Gurugram", avatar: "PS", email: "priya.sharma@example.com" },
  { id: 3, name: "Amit Verma", designation: "Operations Head", company: "Verma Resorts", location: "Noida", avatar: "AV", email: "amit.verma@example.com" },
  { id: 4, name: "Neha Kapoor", designation: "Event Consultant", company: "Kapoor Events", location: "Delhi", avatar: "NK", email: "neha.kapoor@example.com" },
  { id: 5, name: "Karan Malhotra", designation: "Business Development Lead", company: "Malhotra Group", location: "Gurugram", avatar: "KM", email: "karan.malhotra@example.com" },
  { id: 6, name: "Rohit Verma", designation: "Regional Manager", company: "Northline Hospitality", location: "Delhi", avatar: "RV", email: "rohit.verma@example.com" },
  { id: 7, name: "Sneha Kapoor", designation: "Guest Relations Director", company: "Kapoor Events", location: "Noida", avatar: "SK", email: "sneha.kapoor@example.com" },
  { id: 8, name: "Anjali Sharma", designation: "Marketing Head", company: "The Grand Palace", location: "Delhi", avatar: "AS", email: "anjali.sharma@example.com" },
  { id: 9, name: "Vikram Singh", designation: "Founder", company: "Singh Hospitality Ventures", location: "Faridabad", avatar: "VS", email: "vikram.singh@example.com" },
  { id: 10, name: "Ritu Nair", designation: "Partnerships Manager", company: "Nair Leisure Group", location: "Delhi", avatar: "RN", email: "ritu.nair@example.com" },
];

export const nowIso = () => new Date().toISOString();
export const hoursAgoIso = (h) => new Date(Date.now() - h * 60 * 60 * 1000).toISOString();

export const buildAd = (overrides) => {
  const createdAt = overrides.createdAt || nowIso();
  const editDeadline = new Date(new Date(createdAt).getTime() + EDIT_WINDOW_MS).toISOString();
  return {
    reactions: 0,
    comments: 0,
    views: 0,
    selectedPeople: [],
    visibility: VISIBILITY.ALL,
    viewerAccess: "locked",
    ...overrides,
    createdAt,
    editDeadline,
  };
};

export const INITIAL_ADVERTISEMENTS = [
  buildAd({
    id: 2,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    title: "Seeking Banquet Event Coordinators",
    description:
      "The Grand Palace is expanding its events wing and is looking for experienced banquet coordinators for the upcoming wedding season across our Gurugram and Delhi properties.",
    image:
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.SELECTED,
    selectedPeople: [1, 5, 9],
    reactions: 16,
    comments: 4,
    views: 76,
    createdAt: hoursAgoIso(5),
  }),
  buildAd({
    id: 3,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    title: "Corporate Event Vendors Needed",
    description:
      "Kapoor Events is putting together a preferred vendor list for large corporate conferences in Q4. We are especially interested in AV, catering and venue-decor partners.",
    image:
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 31,
    comments: 12,
    views: 204,
    createdAt: hoursAgoIso(10),
  }),
  buildAd({
    id: 4,
    posterId: 9,
    posterName: "Vikram Singh",
    company: "Singh Hospitality Ventures",
    title: "Investment Opportunity: Boutique Property in Delhi",
    description:
      "We are raising a small round for a boutique 24-key property near Connaught Place. Looking to connect with members interested in hospitality real estate.",
    image:
      "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 42,
    comments: 19,
    views: 310,
    createdAt: hoursAgoIso(30),
  }),
  buildAd({
    id: 5,
    posterId: 6,
    posterName: "Rohit Verma",
    company: "Northline Hospitality",
    title: "Hiring: Front Office Trainers",
    description:
      "Northline Hospitality is looking for experienced front office trainers to run a two-week onboarding program for a new property launch in Noida.",
    image:
      "https://images.unsplash.com/photo-1517840901100-8179e982acb7?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.ALL,
    reactions: 9,
    comments: 2,
    views: 58,
    createdAt: hoursAgoIso(48),
  }),
  buildAd({
    id: 6,
    posterId: 10,
    posterName: "Ritu Nair",
    company: "Nair Leisure Group",
    title: "Looking for F&B Concept Partners",
    description:
      "Nair Leisure Group is scouting for independent F&B concepts to bring into our upcoming lifestyle property. Open to rooftop, all-day dining and specialty cuisine concepts.",
    image:
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
    visibility: VISIBILITY.SELECTED,
    selectedPeople: [1, 2, 4],
    reactions: 21,
    comments: 6,
    views: 143,
    createdAt: hoursAgoIso(72),
  }),
];

export const MOCK_VIEWERS = {
  1: [
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 3, name: "Amit Verma", viewedAt: "3h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "4h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "5h" },
    { id: 6, name: "Rohit Verma", viewedAt: "6h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "8h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "9h" },
  ],
  2: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 3, name: "Amit Verma", viewedAt: "2h" },
    { id: 6, name: "Rohit Verma", viewedAt: "4h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "5h" },
  ],
  3: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "3h" },
    { id: 9, name: "Vikram Singh", viewedAt: "5h" },
    { id: 10, name: "Ritu Nair", viewedAt: "7h" },
  ],
  4: [
    { id: 2, name: "Priya Sharma", viewedAt: "3h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "6h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "9h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "12h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "14h" },
    { id: 10, name: "Ritu Nair", viewedAt: "20h" },
  ],
  5: [
    { id: 1, name: "Rahul Mehta", viewedAt: "10h" },
    { id: 9, name: "Vikram Singh", viewedAt: "20h" },
  ],
  6: [
    { id: 1, name: "Rahul Mehta", viewedAt: "5h" },
    { id: 3, name: "Amit Verma", viewedAt: "10h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "15h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "30h" },
    { id: 9, name: "Vikram Singh", viewedAt: "40h" },
  ],
  101: [
    { id: 2, name: "Priya Sharma", viewedAt: "1h" },
    { id: 3, name: "Amit Verma", viewedAt: "2h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "3h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "4h" },
    { id: 6, name: "Rohit Verma", viewedAt: "5h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "7h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "9h" },
    { id: 9, name: "Vikram Singh", viewedAt: "12h" },
    { id: 10, name: "Ritu Nair", viewedAt: "16h" },
    { id: 1, name: "Rahul Mehta", viewedAt: "20h" },
    { id: 11, name: "Rajesh Khanna", viewedAt: "24h" },
    { id: 12, name: "Pooja Gupta", viewedAt: "28h" },
  ],
  102: [
    { id: 1, name: "Rahul Mehta", viewedAt: "1h" },
    { id: 4, name: "Neha Kapoor", viewedAt: "3h" },
    { id: 6, name: "Rohit Verma", viewedAt: "5h" },
    { id: 9, name: "Vikram Singh", viewedAt: "8h" },
    { id: 10, name: "Ritu Nair", viewedAt: "12h" },
    { id: 3, name: "Amit Verma", viewedAt: "18h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "24h" },
    { id: 7, name: "Sneha Kapoor", viewedAt: "30h" },
  ],
  103: [
    { id: 2, name: "Priya Sharma", viewedAt: "2h" },
    { id: 5, name: "Karan Malhotra", viewedAt: "4h" },
    { id: 8, name: "Anjali Sharma", viewedAt: "7h" },
    { id: 10, name: "Ritu Nair", viewedAt: "11h" },
    { id: 1, name: "Rahul Mehta", viewedAt: "15h" },
    { id: 9, name: "Vikram Singh", viewedAt: "20h" },
  ],
  104: [
    { id: 3, name: "Amit Verma", viewedAt: "1h" },
    { id: 6, name: "Rohit Verma", viewedAt: "2h" },
    { id: 9, name: "Vikram Singh", viewedAt: "5h" },
    { id: 10, name: "Ritu Nair", viewedAt: "9h" },
    { id: 2, name: "Priya Sharma", viewedAt: "14h" },
  ],
};

export const REACTION_TYPES = {
  LIKE: "like",
  CELEBRATE: "celebrate",
  SUPPORT: "support",
  LOVE: "love",
  INSIGHTFUL: "insightful",
  FUNNY: "funny",
};

export const REACTION_LABELS = {
  [REACTION_TYPES.LIKE]: "Like",
  [REACTION_TYPES.CELEBRATE]: "Celebrate",
  [REACTION_TYPES.SUPPORT]: "Support",
  [REACTION_TYPES.LOVE]: "Love",
  [REACTION_TYPES.INSIGHTFUL]: "Insightful",
  [REACTION_TYPES.FUNNY]: "Funny",
};

// Icon (emoji) shown for each reaction type
export const REACTION_ICONS = {
  [REACTION_TYPES.CELEBRATE]: "👏", // Claps (Celebrate)
  [REACTION_TYPES.SUPPORT]: "🤝", // Support / handshake
  [REACTION_TYPES.LOVE]: "❤️", // Love
  [REACTION_TYPES.INSIGHTFUL]: "💡", // Insightful (bulb)
  [REACTION_TYPES.FUNNY]: "😂", // Funny
};

export const MOCK_REACTIONS_BY_AD = {
  1: [
    { id: "r1-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "r1-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.CELEBRATE, time: "2h" },
    { id: "r1-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.SUPPORT, time: "3h" },
    { id: "r1-4", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "4h" },
    { id: "r1-5", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "r1-6", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "6h" },
    { id: "r1-7", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "8h" },
    { id: "r1-8", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "9h" },
  ],
  2: [
    { id: "r2-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "r2-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.SUPPORT, time: "2h" },
    { id: "r2-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.INSIGHTFUL, time: "4h" },
    { id: "r2-4", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.LOVE, time: "5h" },
  ],
  3: [
    { id: "r3-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "1h" },
    { id: "r3-2", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "r3-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.FUNNY, time: "3h" },
    { id: "r3-4", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.SUPPORT, time: "5h" },
    { id: "r3-5", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "7h" },
  ],
  4: [
    { id: "r4-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "3h" },
    { id: "r4-2", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.LIKE, time: "6h" },
    { id: "r4-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "9h" },
    { id: "r4-4", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.SUPPORT, time: "12h" },
    { id: "r4-5", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.CELEBRATE, time: "14h" },
    { id: "r4-6", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.LOVE, time: "20h" },
  ],
  5: [
    { id: "r5-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "10h" },
    { id: "r5-2", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LOVE, time: "20h" },
  ],
  6: [
    { id: "r6-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.SUPPORT, time: "5h" },
    { id: "r6-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "10h" },
    { id: "r6-3", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.FUNNY, time: "15h" },
    { id: "r6-4", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "30h" },
    { id: "r6-5", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LOVE, time: "40h" },
  ],
};

export const MOCK_REACTIONS_BY_POST = {
  901: [
    { id: "p901-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "1h" },
    { id: "p901-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p901-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "3h" },
  ],
  902: [
    { id: "p902-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p902-2", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.SUPPORT, time: "6h" },
    { id: "p902-3", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.INSIGHTFUL, time: "8h" },
  ],
  903: [
    { id: "p903-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.CELEBRATE, time: "5h" },
    { id: "p903-2", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "7h" },
  ],
  904: [
    { id: "p904-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LOVE, time: "1h" },
    { id: "p904-2", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p904-3", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.SUPPORT, time: "3h" },
  ],
  101: [
    { id: "p101-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "p101-2", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.CELEBRATE, time: "2h" },
    { id: "p101-3", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.SUPPORT, time: "3h" },
    { id: "p101-4", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p101-5", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "p101-6", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.LOVE, time: "7h" },
    { id: "p101-7", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "9h" },
    { id: "p101-8", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.LIKE, time: "12h" },
    { id: "p101-9", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.SUPPORT, time: "16h" },
    { id: "p101-10", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.CELEBRATE, time: "20h" },
    { id: "p101-11", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.INSIGHTFUL, time: "26h" },
    { id: "p101-12", memberId: 7, name: "Sneha Kapoor", type: REACTION_TYPES.LIKE, time: "32h" },
  ],
  102: [
    { id: "p102-1", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "1h" },
    { id: "p102-2", memberId: 4, name: "Neha Kapoor", type: REACTION_TYPES.CELEBRATE, time: "3h" },
    { id: "p102-3", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LOVE, time: "5h" },
    { id: "p102-4", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.SUPPORT, time: "8h" },
    { id: "p102-5", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.INSIGHTFUL, time: "12h" },
    { id: "p102-6", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LIKE, time: "18h" },
    { id: "p102-7", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.FUNNY, time: "24h" },
  ],
  103: [
    { id: "p103-1", memberId: 2, name: "Priya Sharma", type: REACTION_TYPES.SUPPORT, time: "2h" },
    { id: "p103-2", memberId: 5, name: "Karan Malhotra", type: REACTION_TYPES.LIKE, time: "4h" },
    { id: "p103-3", memberId: 8, name: "Anjali Sharma", type: REACTION_TYPES.INSIGHTFUL, time: "7h" },
    { id: "p103-4", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.CELEBRATE, time: "11h" },
    { id: "p103-5", memberId: 1, name: "Rahul Mehta", type: REACTION_TYPES.LIKE, time: "15h" },
  ],
  104: [
    { id: "p104-1", memberId: 3, name: "Amit Verma", type: REACTION_TYPES.LOVE, time: "1h" },
    { id: "p104-2", memberId: 6, name: "Rohit Verma", type: REACTION_TYPES.LIKE, time: "2h" },
    { id: "p104-3", memberId: 9, name: "Vikram Singh", type: REACTION_TYPES.INSIGHTFUL, time: "5h" },
    { id: "p104-4", memberId: 10, name: "Ritu Nair", type: REACTION_TYPES.SUPPORT, time: "9h" },
  ],
};

export const MOCK_COMMENTS_BY_AD = {
1: [
    { id: "c1-1", memberId: 2, name: "Priya Sharma", text: "This is exactly what we have been looking for. Sharing with our board.", timestamp: "1h" },
    { id: "c1-2", memberId: 3, name: "Amit Verma", text: "We have two mid-format properties in Gurugram. Happy to connect.", timestamp: "2h" },
    { id: "c1-3", memberId: 8, name: "Anjali Sharma", text: "Interested in the revenue-share model. Can you share more details?", timestamp: "4h" },
    { id: "c1-4", memberId: 5, name: "Karan Malhotra", text: "Great opportunity for regional partners.", timestamp: "6h" },
    { id: "c1-5", memberId: 1, name: "Rahul Mehta", text: "Let us schedule a call this week.", timestamp: "3h" },
    { id: "c1-6", memberId: 6, name: "Rohit Verma", text: "Sent you a connection request.", timestamp: "5h" },
    { id: "c1-7", memberId: 4, name: "Neha Kapoor", text: "We manage similar properties, keen to discuss.", timestamp: "7h" },
    { id: "c1-8", memberId: 9, name: "Vikram Singh", text: "AV and event support available.", timestamp: "8h" },
    { id: "c1-9", memberId: 7, name: "Sneha Kapoor", text: "Good margins on paper, want details.", timestamp: "9h" },
    { id: "c1-10", memberId: 10, name: "Ritu Nair", text: "Confirming our interest for the region.", timestamp: "10h" },
    { id: "c1-11", memberId: 2, name: "Priya Sharma", text: "Sharing deck with the investment team.", timestamp: "11h" },
    { id: "c1-12", memberId: 3, name: "Amit Verma", text: "Also exploring two more locations.", timestamp: "12h" },
    { id: "c1-13", memberId: 5, name: "Karan Malhotra", text: "Let us connect on partnership terms.", timestamp: "13h" },
  ],
  2: [
    { id: "c2-1", memberId: 1, name: "Rahul Mehta", text: "We have experienced coordinators available.", timestamp: "1h" },
    { id: "c2-2", memberId: 6, name: "Rohit Verma", text: "Sent you a message about this.", timestamp: "3h" },
  ],
  3: [
    { id: "c3-1", memberId: 5, name: "Karan Malhotra", text: "Our catering team would be a great fit.", timestamp: "2h" },
    { id: "c3-2", memberId: 9, name: "Vikram Singh", text: "AV vendor list ready to share.", timestamp: "5h" },
    { id: "c3-3", memberId: 10, name: "Ritu Nair", text: "Count us in for venue decor.", timestamp: "8h" },
  ],
  4: [
    { id: "c4-1", memberId: 8, name: "Anjali Sharma", text: "Would love to know the ticket size.", timestamp: "4h" },
    { id: "c4-2", memberId: 2, name: "Priya Sharma", text: "Delhi property sounds interesting.", timestamp: "10h" },
  ],
  5: [],
  6: [
    { id: "c6-1", memberId: 2, name: "Priya Sharma", text: "Open to a rooftop discussion.", timestamp: "2h" },
  ],
};

export const MOCK_COMMENTS_BY_POST = {
  901: [
    { id: "pc901-1", memberId: 4, name: "Neha Kapoor", text: "The rooftop sounds fantastic, counting down!", timestamp: "2h" },
    { id: "pc901-2", memberId: 1, name: "Rahul Mehta", text: "Excited to see this launch.", timestamp: "1h" },
  ],
  902: [
    { id: "pc902-1", memberId: 9, name: "Vikram Singh", text: "I will be there, looking forward to it.", timestamp: "6h" },
    { id: "pc902-2", memberId: 2, name: "Priya Sharma", text: "Can you share the agenda?", timestamp: "2h" },
    { id: "pc902-3", memberId: 3, name: "Amit Verma", text: "Our operations head is attending too.", timestamp: "1h" },
  ],
  903: [
    { id: "pc903-1", memberId: 6, name: "Rohit Verma", text: "Great topic, will join the session.", timestamp: "12h" },
    { id: "pc903-2", memberId: 10, name: "Ritu Nair", text: "Live sessions are always useful.", timestamp: "8h" },
    { id: "pc903-3", memberId: 1, name: "Rahul Mehta", text: "Sharing this with my events team, we are in.", timestamp: "7h" },
    { id: "pc903-4", memberId: 2, name: "Priya Sharma", text: "Count on our venue booking too.", timestamp: "6h" },
    { id: "pc903-5", memberId: 3, name: "Amit Verma", text: "Our decor team will coordinate.", timestamp: "6h" },
    { id: "pc903-6", memberId: 4, name: "Neha Kapoor", text: "Looks promising, added to calendar.", timestamp: "5h" },
    { id: "pc903-7", memberId: 5, name: "Karan Malhotra", text: "Great initiative for sustainability.", timestamp: "5h" },
    { id: "pc903-8", memberId: 7, name: "Sneha Kapoor", text: "Will attend, thanks for organizing.", timestamp: "4h" },
    { id: "pc903-9", memberId: 8, name: "Anjali Sharma", text: "Interested in the speakers lineup.", timestamp: "4h" },
    { id: "pc903-10", memberId: 9, name: "Vikram Singh", text: "Our photographer can cover the event.", timestamp: "3h" },
    { id: "pc903-11", memberId: 6, name: "Rohit Verma", text: "Also sharing the agenda with our team.", timestamp: "3h" },
    { id: "pc903-12", memberId: 1, name: "Rahul Mehta", text: "Any partner slots still available?", timestamp: "2h" },
    { id: "pc903-13", memberId: 10, name: "Ritu Nair", text: "Yes, would love to collaborate.", timestamp: "1h" },
  ],
  904: [
    { id: "pc904-1", memberId: 1, name: "Rahul Mehta", text: "Count me in for Friday.", timestamp: "20h" },
    { id: "pc904-2", memberId: 5, name: "Karan Malhotra", text: "Will bring the regional team along.", timestamp: "14h" },
  ],
  101: [
    { id: "pc101-1", memberId: 7, name: "Sneha Kapoor", text: "We may be interested. Can we discuss offline?", timestamp: "1h" },
    { id: "pc101-2", memberId: 6, name: "Rohit Verma", text: "Shared internally with our expansion team.", timestamp: "3h" },
    { id: "pc101-3", memberId: 10, name: "Ritu Nair", text: "Revenue-share structure looks interesting.", timestamp: "5h" },
  ],
  102: [
    { id: "pc102-1", memberId: 8, name: "Anjali Sharma", text: "We have banquet coordinators who fit this.", timestamp: "2h" },
    { id: "pc102-2", memberId: 1, name: "Rahul Mehta", text: "Reached out via message.", timestamp: "4h" },
  ],
  103: [
    { id: "pc103-1", memberId: 5, name: "Karan Malhotra", text: "Our catering team would be a great fit.", timestamp: "6h" },
    { id: "pc103-2", memberId: 9, name: "Vikram Singh", text: "AV vendor list ready to share.", timestamp: "8h" },
    { id: "pc103-3", memberId: 10, name: "Ritu Nair", text: "Count us in for venue decor.", timestamp: "9h" },
  ],
  104: [
    { id: "pc104-1", memberId: 2, name: "Priya Sharma", text: "This could suit our investors network.", timestamp: "4h" },
    { id: "pc104-2", memberId: 4, name: "Neha Kapoor", text: "Happy to introduce potential partners.", timestamp: "7h" },
  ],
};

export const MOCK_REACTIONS = [
  { id: 1, name: "Amit Verma", text: "Interested!" },
  { id: 2, name: "Priya Sharma", text: "This looks great!" },
  { id: 3, name: "Karan Malhotra", text: "Can you share more details?" },
  { id: 4, name: "Sneha Kapoor", text: "Sent you a message about this." },
];

export function formatTimeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "now";
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d`;
  const months = Math.floor(days / 30);
  return `${months}mo`;
}

export function getAdvertisementEditState(postedAt, currentTime = new Date()) {
  const posted = new Date(postedAt).getTime();
  const now = new Date(currentTime).getTime();
  const elapsed = now - posted;
  return elapsed < EDIT_WINDOW_MS ? "editable" : "locked";
}

export function getRemainingEditTime(postedAt, currentTime = new Date()) {
  const posted = new Date(postedAt).getTime();
  const now = new Date(currentTime).getTime();
  const remainingMs = Math.max(0, posted + EDIT_WINDOW_MS - now);
  const totalMinutes = Math.floor(remainingMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { hours, minutes, remainingMs };
}

export function formatCountdown(postedAt, currentTime = new Date()) {
  const { hours, minutes } = getRemainingEditTime(postedAt, currentTime);
  return `${hours} hour${hours === 1 ? "" : "s"} ${minutes} minute${minutes === 1 ? "" : "s"} remaining`;
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getMemberById(id) {
  return MOCK_MEMBERS.find((m) => m.id === id);
}

/* ============================================================
   Advertisement Posts & Events
   ============================================================ */

export const POST_VISIBILITY = { ANYONE: "anyone", CONNECTIONS: "connections" };
export const COMMENT_PERMISSION = { ANYONE: "anyone", CONNECTIONS: "connections", OFF: "off" };
export const EVENT_TYPE = { ONLINE: "online", IN_PERSON: "in_person" };

export const POST_MAX_PHOTOS = 5;
export const POST_MAX_MEDIA = 5;
export const POST_MAX_VIDEOS = 1;
export const POST_MAX_TEXT = 1000;
export const EVENT_NAME_MAX = 75;
export const EVENT_TITLE_MAX = 100;
export const EVENT_DESC_MAX = 1000;
export const COMMENT_MAX_WORDS = 1000;
export const EVENT_LINK_MAX = 1000;
export const EVENT_WORD_MAX = 100;
export const POST_TITLE_MAX_WORDS = 100;
export const EVENT_COVER_MIN_WIDTH = 480;
export const EVENT_COVER_MAX_MEDIA = 5;
export const EVENT_COVER_MAX_VIDEOS = 1;

export const TIMEZONES = [
  "(GMT+05:30) India Standard Time (IST)",
  "(GMT+00:00) Greenwich Mean Time (GMT)",
  "(GMT-05:00) Eastern Time (ET)",
  "(GMT-08:00) Pacific Time (PT)",
  "(GMT+01:00) Central European Time (CET)",
  "(GMT+08:00) Singapore Time (SGT)",
  "(GMT+09:00) Japan Standard Time (JST)",
  "(GMT+04:00) Gulf Standard Time (GST)",
  "(GMT+10:00) Australian Eastern Time (AEST)",
];

export const buildEvent = (overrides = {}) => ({
  id: null,
  coverPhotos: [],
  coverVideo: "",
  coverVideoIndex: -1,
  coverVideoEdits: null,
  coverThumbnail: null,
  coverThumbnails: [],
  eventType: EVENT_TYPE.ONLINE,
  name: "",
  nameColor: "#000000",
  nameSize: 20,
  nameWeight: 700,
  nameItalic: false,
  nameUnderline: false,
  nameFontFamily: "auto",
  titleColor: "#000000",
  titleSize: 20,
  titleWeight: 700,
  titleItalic: false,
  titleUnderline: false,
  titleFontFamily: "auto",
  timezone: TIMEZONES[0],
  startDate: "",
  startTime: "",
  hasEndDate: false,
  endDate: "",
  endTime: "",
  address: "",
  venue: "",
  title: "",
  description: "",
  descColor: "#1a1a1a",
  descSize: 14,
  descWeight: 400,
  descItalic: false,
  descUnderline: false,
  descFontFamily: "auto",
  gif: null,
  externalLink: "",
  visibility: POST_VISIBILITY.ANYONE,
  commentPermission: COMMENT_PERMISSION.ANYONE,
  emojiEnabled: true,
  hideLikes: false,
  hideLikeCount: false,
  hideComments: false,
  hideCommentCount: false,
  socials: [],
  taggedPeople: [],
  ...overrides,
});

export const buildPost = (overrides = {}) => ({
  id: null,
  posterId: CURRENT_USER_ID,
  posterName: getMemberById(CURRENT_USER_ID).name,
  company: getMemberById(CURRENT_USER_ID).company,
  avatar: getMemberById(CURRENT_USER_ID).avatar,
  text: "",
  textColor: "#1a1a1a",
  textSize: 16,
  textWeight: 400,
  textItalic: false,
  textUnderline: false,
  title: "",
  titleColor: "#000000",
  titleSize: 20,
  titleWeight: 600,
  titleItalic: false,
  titleUnderline: false,
  visibility: POST_VISIBILITY.ANYONE,
  commentPermission: COMMENT_PERMISSION.ANYONE,
  emojiEnabled: true,
  hideLikes: false,
  hideComments: false,
  hideLikeCount: false,
  hideCommentCount: false,
  photos: [],
  video: null,
  videoEdits: [],
  videoThumbnail: null,
  videoThumbnails: [],
  gif: null,
  youtube: null,
  event: null,
  taggedPeople: [],
  location: "",
  createdAt: nowIso(),
  ...overrides,
});

const SAMPLE_SOCIAL_VALUES = {
  whatsapp: "+91 555 010 010",
  linkedin: "linkedin.com/in/sample",
  facebook: "facebook.com/sample",
  gmail: "sample@gmail.com",
  twitter: "sample",
  youtube: "youtube.com/@sample",
};

const sampleSocials = (ids) =>
  ids.map((id) => ({
    id,
    value: SAMPLE_SOCIAL_VALUES[id] || "sample",
  }));

/* Bump this whenever INITIAL_POSTS (or any other seed data the store mines)
   changes, so running apps refresh their shared state instead of keeping stale
   snapshots captured before the edit. */
export const ADVERTISEMENT_SEED_VERSION = 5;

export const INITIAL_POSTS = [
  buildPost({
    id: 930,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Unwind in our Luxury Suite with panoramic city views, king-size bed, private balcony, and complimentary breakfast for two. Book now and save 20% on your weekend getaway!",
    photos: [
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Weekend Staycation — Luxury Suite at ₹4,999/night",
    location: "ABC Hospitality, Connaught Place, New Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(1),
  }),
  buildPost({
    id: 931,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Escape to the mountains with our exclusive Manali Family Package — 3 nights, 4 days including stay, breakfast, sightseeing, and transfers. Starting at ₹12,999 per couple. Limited slots for October!",
    photos: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Manali Family Package — 3N/4D from ₹12,999",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(2),
  }),
  buildPost({
    id: 932,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Experience royal hospitality at our Jaipur Heritage Hotel. Marble floors, courtyard dining, and a rooftop pool overlooking the pink city. Flat 25% off on weekday bookings!",
    photos: [
      "https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Jaipur Heritage Hotel — Flat 25% Off Weekdays",
    location: "Jaipur, Rajasthan",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(4),
  }),
  buildPost({
    id: 933,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Plan your dream wedding with us! Our banquet halls seat up to 500 guests with in-house catering, decor and valet. Get a free tasting session when you book before 30th September.",
    photos: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Wedding Banquet Package — Book & Get Free Tasting",
    location: "The Grand Pavilion, Aerocity, New Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook"]),
    createdAt: hoursAgoIso(6),
  }),
  buildPost({
    id: 934,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Corporate offsite sorted! Our business conference halls come with projectors, high-speed WiFi, tea breaks, and lunch buffets. Day packages starting at ₹1,499 per person.",
    photos: [
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Corporate Conference Hall — Day Package ₹1,499/person",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(11),
  }),
  buildPost({
    id: 935,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Beach vibes await! Our Goa Beach Resort package includes 2 nights stay, breakfast, airport transfers, and a sunset cruise. Couple package at ₹9,999 all-inclusive.",
    photos: [
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Goa Beach Resort — 2N Couple Package ₹9,999",
    location: "ABC Beach Resort, Calangute, Goa",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail"]),
    createdAt: hoursAgoIso(15),
  }),
  buildPost({
    id: 936,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Spa weekend anyone? Our wellness retreat includes a 90-min aromatherapy massage, jacuzzi access, herbal lunch, and a guided yoga session. Couple spa at ₹6,499.",
    photos: [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Spa & Wellness Retreat — Couple Spa at ₹6,499",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "twitter"]),
    createdAt: hoursAgoIso(22),
  }),
  buildPost({
    id: 937,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Celebrate New Year's Eve at our rooftop lounge with a live DJ, dinner buffet, unlimited drinks and fireworks views. Early bird tickets at ₹2,999 per person. Limited to 200 guests.",
    photos: [
      "https://images.unsplash.com/photo-1530023367847-a683933f4172?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "New Year's Eve Gala — ₹2,999/person (Early Bird)",
    location: "Rooftop Lounge, ABC Hospitality, Delhi",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "youtube"]),
    createdAt: hoursAgoIso(26),
  }),
  buildPost({
    id: 901,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    avatar: "PS",
    text: "Honeymoon special at The Grand Palace! Royal suite with rose petal welcome, candlelight dinner, couples spa, and a heritage walk. All-inclusive package from ₹18,999 for 2 nights.",
    photos: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Honeymoon Package — 2N Royal Suite from ₹18,999",
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(3),
  }),
  buildPost({
    id: 902,
    posterId: 5,
    posterName: "Karan Malhotra",
    company: "Malhotra Group",
    avatar: "KM",
    text: "Pilgrim's comfort! Our Rishikesh riverside resort offers AC rooms with Ganga views, yoga sessions, sattvic meals, and guided temple tours. 3-night package at ₹8,499 per person.",
    photos: [
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Rishikesh Riverside Retreat — 3N at ₹8,499/person",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(9),
  }),
  buildPost({
    id: 903,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    avatar: "NK",
    text: "Book your corporate offsite with Kapoor Events and get end-to-end planning — venue, team activities, DJ night, bonfire and adventure sports. Packages from ₹3,499 per person/day.",
    photos: [
      "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Corporate Offsite Planning — From ₹3,499/person/day",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(20),
  }),
  buildPost({
    id: 904,
    posterId: 7,
    posterName: "Sneha Kapoor",
    company: "The Grand Palace",
    avatar: "SK",
    text: "Summer escape to Shimla! Our hillside resort offers valley-view rooms, campfire evenings, nature trails and kids play area. Family of 4 package at ₹14,999 for 3 nights.",
    photos: [
      "https://images.unsplash.com/photo-1587061949409-02df41d5e562?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Shimla Family Getaway — 3N/4D Family Pack ₹14,999",
    socials: sampleSocials(["linkedin", "facebook", "twitter"]),
    createdAt: hoursAgoIso(30),
  }),
  buildPost({
    id: 101,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Weekday business traveler? Stay 3 nights at any ABC property and get the 4th night free. Valid across Delhi, Noida, Gurugram and Chandigarh properties. Use code STAY4.",
    photos: [
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Stay 3, Get 1 Free — Business Travel Offer",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(2),
  }),
  buildPost({
    id: 110,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Holiday season is here! Book any ABC property for 5+ nights between October and December and receive a complimentary dinner for two. Early bird bonus — free room upgrade!",
    photos: [
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Holiday Season Offer — 5N Stay + Free Dinner",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(1),
  }),
  buildPost({
    id: 111,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Foodie alert! Our rooftop restaurant now offers a 5-course tasting menu with craft cocktails every Friday and Saturday evening. Reservations open — table for two at ₹2,499.",
    photos: [
      "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Rooftop Tasting Menu — 5 Courses at ₹2,499 for 2",
    location: "ABC Rooftop, Connaught Place, New Delhi",
    socials: sampleSocials(["whatsapp", "youtube"]),
    createdAt: hoursAgoIso(4),
  }),
  buildPost({
    id: 112,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Fitness retreat alert! Our wellness camp includes gym sessions, spa, organic meals, guided trekking and meditation. 5-day detox package at ₹11,999 per person.",
    photos: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "5-Day Fitness & Detox Retreat — ₹11,999/person",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook"]),
    createdAt: hoursAgoIso(6),
  }),
  buildPost({
    id: 113,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Destination wedding at our Udaipur lakeside palace venue. Packages include mandap, pheras, reception, 200 guest rooms, catering and decor. Starting at ₹45 lakhs all-inclusive.",
    photos: [
      "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1522413452208-996ff3f3e740?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Udaipur Destination Wedding — From ₹45 Lakhs",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(11),
  }),
  buildPost({
    id: 114,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Pondicherry beach villa for rent! 3BHK private villa with pool, 2 min walk to beach, BBQ setup and caretaker. Weekend rate ₹8,999/night. Perfect for group getaways.",
    photos: [
      "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Pondicherry Beach Villa — ₹8,999/night (3BHK)",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail"]),
    createdAt: hoursAgoIso(15),
  }),
  buildPost({
    id: 115,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Diwali special — gift your loved ones an ABC Hospitality gift card. ₹5,000 value at just ₹4,250. Redeemable at any of our 12 properties across India. Offer valid till 20th October.",
    photos: [
      "https://images.unsplash.com/photo-1607082349566-187342175e2f?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1549488344-cbb6c34cf1ac?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Diwali Gift Card — ₹5,000 for ₹4,250",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "twitter"]),
    createdAt: hoursAgoIso(22),
  }),
  buildPost({
    id: 116,
    posterId: 1,
    posterName: "Rahul Mehta",
    company: "ABC Hospitality",
    avatar: "RM",
    text: "Adventure lover? Our Manali adventure package includes paragliding, river rafting, zip-lining and camping under the stars. 2N/3D at ₹7,999 per person. Includes all gear and guides.",
    photos: [
      "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Manali Adventure Pack — 2N/3D at ₹7,999/person",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "youtube"]),
    createdAt: hoursAgoIso(26),
  }),
  buildPost({
    id: 102,
    posterId: 2,
    posterName: "Priya Sharma",
    company: "The Grand Palace",
    avatar: "PS",
    text: "Anniversary celebration package includes rose-decorated suite, candlelight dinner by the pool, couples spa session and a midnight cake. Book for ₹14,999 — includes all taxes.",
    photos: [
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Anniversary Special — ₹14,999 All-Inclusive",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(5),
  }),
  buildPost({
    id: 103,
    posterId: 4,
    posterName: "Neha Kapoor",
    company: "Kapoor Events",
    avatar: "NK",
    text: "Kid's birthday party at Kapoor Events! Theme decor, gaming zone, magician, candy counter and a custom cake. Packages starting at ₹9,999 for 20 kids. Weekend slots filling fast!",
    photos: [
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1530023367847-a683933f4172?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Kids Birthday Party — From ₹9,999 (20 kids)",
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(10),
  }),
  buildPost({
    id: 104,
    posterId: 9,
    posterName: "Vikram Singh",
    company: "Singh Hospitality Ventures",
    avatar: "VS",
    text: "Weekend farmstay near Delhi! Organic farm, bonfire, stargazing, tractor ride and farm-to-table meals. 1N/2D at ₹3,499 per person. Just 3 hours from Delhi. Perfect for families.",
    photos: [
      "https://images.unsplash.com/photo-1500076656116-558758c991c1?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Delhi Farmstay — 1N/2D at ₹3,499/person",
    socials: sampleSocials(["whatsapp", "linkedin", "facebook", "gmail", "twitter", "youtube"]),
    createdAt: hoursAgoIso(30),
  }),
  buildPost({
    id: 105,
    posterId: 6,
    posterName: "Rohit Verma",
    company: "Northline Hospitality",
    avatar: "RV",
    text: "Snow Leopard Trek in Ladakh! 7-day guided trek with camping, meals, permits and transport from Leh. Only ₹22,999 per person. October batch — 4 seats left!",
    photos: [
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Ladakh Snow Leopard Trek — 7D at ₹22,999",
    socials: sampleSocials(["whatsapp", "gmail"]),
    createdAt: hoursAgoIso(48),
  }),
  buildPost({
    id: 106,
    posterId: 10,
    posterName: "Ritu Nair",
    company: "Nair Leisure Group",
    avatar: "RN",
    text: "Kerala houseboat luxury cruise! 1N on a premium AC houseboat with all meals, backwater sightseeing and sunset cruise. Couple package at ₹7,499. Available year-round.",
    photos: [
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1200&q=80",
      "https://images.unsplash.com/photo-1516690561799-46d8f74f9abf?auto=format&fit=crop&w=1200&q=80",
    ],
    title: "Kerala Houseboat Cruise — 1N Couple Pack ₹7,499",
    socials: sampleSocials(["whatsapp", "linkedin", "youtube"]),
    createdAt: hoursAgoIso(72),
  }),
];

export function isValidUrl(value) {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function formatDateLabel(date, time) {
  if (!date) return "";
  const d = new Date(`${date}T${time || "00:00"}:00`);
  if (isNaN(d.getTime())) return date;
  return d.toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export const REPORT_REASONS = [
  { id: "spam", label: "Spam" },
  { id: "harassment", label: "Harassment or bullying" },
  { id: "hate_speech", label: "Hate speech" },
  { id: "violence", label: "Violence or dangerous content" },
  { id: "misinformation", label: "False or misleading information" },
  { id: "ip_violation", label: "Intellectual property violation" },
  { id: "nudity", label: "Nudity or sexual content" },
  { id: "nc_imagery", label: "Nonconsensual intimate imagery" },
  { id: "scam", label: "Scam or fraud" },
  { id: "other", label: "Other" },
];

export const REPORT_OTHER_MAX = 1000;

/* ============================================================
   Advertisement shared state store
   ============================================================ */

const buildInitialState = () => ({
  posts: INITIAL_POSTS,
  followingPosters: new Set(),
  savedPosts: new Set(),
  archivedPosts: new Set(),
  hiddenPosts: new Set(),
  hiddenLikeCounts: new Set(),
  hiddenCommentCounts: new Set(),
  likedPosts: new Map(),
});

let state = null;
let appliedVersion = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

const ensureState = () => {
  if (!state || appliedVersion !== ADVERTISEMENT_SEED_VERSION) {
    state = buildInitialState();
    appliedVersion = ADVERTISEMENT_SEED_VERSION;
    notify();
  }
  return state;
};

export const getAdvertisementState = () => ensureState();

export const publishAdvertisementState = (next) => {
  state = next;
  appliedVersion = ADVERTISEMENT_SEED_VERSION;
  notify();
};

export const updateAdvertisementState = (fn) => {
  publishAdvertisementState(typeof fn === "function" ? fn(ensureState()) : fn);
};

const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const useAdvertisementState = () =>
  useSyncExternalStore(subscribe, getAdvertisementState, getAdvertisementState);
